import axios from "axios";

let navigate = null;
let store = null;
let addToast = null;
const instance = axios?.create();
instance.defaults.timeout = 120000;

instance.interceptors.response.use(
  (response) => {
    const { authorization } = response?.headers;

    if (authorization) {
      localStorage.setItem("authorization", `Bearer: ${authorization}`);
    }
    if (authorization === null) {
      localStorage.removeItem("authorization");
    }
    return response;
  },
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem("authorization");
      if (store) {
        store.dispatch({
          type: "dashboard/updateLoginStatus",
          payload: {
            isLoggedin: false,
          },
        });
      }
      if (navigate) {
        navigate("/"); 
      }
       if (addToast) {
        addToast("Session expired. You have been logged out.", "error");
      }
    }
    return Promise.reject(error);
  }
);

instance.interceptors.request.use((config) => {
  const authorization = localStorage.getItem("authorization");
  if (authorization) {
    config.headers.Authorization = authorization;
  }
  return config;
});

const setDefaultHeaders = (accessToken) => {
  instance.defaults.headers.common["Authorization"] = accessToken;
};

const getDefaultHeaders = () => {
  return instance.defaults.headers;
};

let cancelTokenSource = axios.CancelToken.source();

const axiosCancel = () => {
  const resetCancelToken = () => {
    cancelTokenSource.cancel("HTTP Request canceled");
    cancelTokenSource = axios.CancelToken.source();
  };
  const getCancelToken = () => {
    return cancelTokenSource.token;
  };
  return {
    resetCancelToken,
    getCancelToken,
  };
};

const CancelHTTPRequest = () => {
  axiosCancel().resetCancelToken();
};
const setAxiosDependencies = ({ navigateRef, storeRef, addToastRef }) => {
  navigate = navigateRef;
  store = storeRef;
  addToast = addToastRef;
};
const axiosClient = {
  get: instance.get,
  post: instance.post,
  put: instance.put,
  delete: instance.delete,
  setDefaultHeaders,
  getDefaultHeaders,
  axiosCancel,
  CancelHTTPRequest,
  setAxiosDependencies,
};

export default axiosClient;
